import { ITermCourse } from '../../../../interfaces/scheduler_interfaces';
import { TermCourseServant } from '../../servants/term_course_servant';
import * as _4 from 'lodash4';

class CourseIconsController {
  private course: ITermCourse;
  private showAlert: boolean;
  private hasMissingPrereqs: boolean;
  private hasMissingCoreqs: boolean;
  private hasPrereqs: boolean = false;
  private hasCoreqs: boolean = false;
  private isCoreqEnforcementEnabled: boolean;
  private isDevreq: boolean;
  private coursePreReqContent: string;
  private courseCoReqContent: string;
  private courseContent: string;
  private courseInfoTheme: string;
  private iconId: string;

  constructor(private ngTermCourseServant: TermCourseServant) {}

  // TODO: Recuce complexity
  /* tslint:disable:cognitive-complexity */
  initialize() {
    this.hasMissingPrereqs = this.ngTermCourseServant.hasPreRequistes(this.course);
    this.hasMissingCoreqs = this.ngTermCourseServant.hasCoRequistes(this.course);
    this.isDevreq = this.ngTermCourseServant.isDevReq(this.course);
    this.courseInfoTheme = this.hasMissingCoreqs || this.hasMissingPrereqs ? 'red' : 'gray-dark';
    this.iconId = _4.uniqueId('icon_');
    this.showAlert = this.hasMissingPrereqs || this.hasMissingCoreqs;
    this.hasCoreqs = _4.get(this.course, 'has_coreq', false);
    this.hasPrereqs = _4.get(this.course, 'has_prereq', false);
    const missingPreReqs = this.course._missing_prereqs;
    const missingCoReqs = this.course._missing_coreqs;
    const needsAttentionTemplate = `<strong class='clr-error-txt text-bold'>Needs Attention</strong>`;

    const cautionTitlePrereqs = this.hasMissingPrereqs ? needsAttentionTemplate : '';
    const cautionTitleCoreqs =
      this.hasMissingCoreqs && this.isCoreqEnforcementEnabled
        ? "<strong class='clr-error-txt text-bold'>Must be taken with (co-requisites): </strong>"
        : this.hasMissingCoreqs
        ? needsAttentionTemplate
        : '';

    const courseTitleTemplate = (courses: ITermCourse[], isEnforcedCoReqs: boolean = false) => {
      const specialClass = isEnforcedCoReqs ? `clr-primary-txt` : ``;
      return _4.reduce(
        courses,
        (concat, course) => {
          return `${concat} <li class="${specialClass}"><strong class='text-bold'>${course.cd}</strong> ${course.title}</li>`;
        },
        ''
      );
    };

    const preReqCourseTemplate = this.hasMissingPrereqs
      ? `<p class='mtm'> One (or more) of these prerequisites need to be added to an earlier term. Click the course name for more details </p>
      <ul>${courseTitleTemplate(missingPreReqs)}</ul>`
      : ``;

    const coReqCourseTemplate = this.hasMissingCoreqs
      ? `<p class='mtm'>One (or more) of these co-requisites need to be added to the same term as this course. Click the course name for more details</p>
      <ul>${courseTitleTemplate(missingCoReqs)}</ul> <hr class='mbl mtm'>`
      : ``;

    const enforcedCoReqCourseTemplate = this.hasMissingCoreqs
      ? `<strong class='clr-rust-txt text-bold'>Must be taken with (co-requisites): </strong>
      <ul>${courseTitleTemplate(missingCoReqs, this.isCoreqEnforcementEnabled)}</ul>`
      : ``;

    this.coursePreReqContent = this.hasMissingPrereqs ? `${cautionTitlePrereqs}${preReqCourseTemplate}` : ``;

    this.courseCoReqContent = this.hasMissingCoreqs
      ? `${this.isCoreqEnforcementEnabled ? enforcedCoReqCourseTemplate : coReqCourseTemplate}`
      : ``;

    this.courseContent = `${this.coursePreReqContent}${this.courseCoReqContent}
                          <p><strong class='text-bold'>Credits</strong> ${this.course.credits}</p>
                          <strong class='text-bold'>Course Description</strong>
                          <p>${this.course.desc}</p>`;
  }

  $onInit() {
    this.initialize();
  }

  $onChanges(changes: { course: ITermCourse }) {
    this.initialize();
  }
}

class CourseIconsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      course: '<',
      isCoreqEnforcementEnabled: '<'
    };
    this.controller = CourseIconsController;
    this.templateUrl = 'capability-ng-scheduler/src/views/term_courses/components/course_icons/course_icons.html';
  }
}
angular.module('capability-ng-scheduler').component('courseIcons', new CourseIconsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/components/course_icons/course_icons.ts